module.exports = __webpack_public_path__ + "img/sym4.764fd79f.png";